//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ConfigService } from "@nuskin/ns-util";

import { getFullUrl } from "@nuskin/ns-common-lib";

export default {
  name: "NsTopnavImageOverlay",
  props: {
    /**
     * Image source url
     */
    src: {
      type: String,
      default: ""
    },
    /**
     * alt text of the image for accessibility
     */
    alt: {
      type: String,
      default: "Top Nav Image"
    },
    /**
     * Text for the bottom overlay
     */
    overlayText: {
      type: String,
      default: ""
    }
  },
  data: function() {
    return {
      localSrc: undefined
    };
  },
  watch: {
    src(newVal) {
      this.setSrc(newVal);
    }
  },
  mounted: function() {
    this.setSrc();
  },
  methods: {
    setSrc(src = this.src) {
      const marketConfig = ConfigService.getMarketConfig();
      this.localSrc = getFullUrl(marketConfig.siteUrl, src);
    }
  }
};
